import { render, staticRenderFns } from "./MongoDBDash.vue?vue&type=template&id=29f283a0&scoped=true&"
import script from "./MongoDBDash.vue?vue&type=script&lang=js&"
export * from "./MongoDBDash.vue?vue&type=script&lang=js&"
import style0 from "./MongoDBDash.vue?vue&type=style&index=0&id=29f283a0&scoped=true&lang=scss&"
import style1 from "./MongoDBDash.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f283a0",
  null
  
)

export default component.exports